'use strict';
import Security from '@/_helpers/security.js';

const FooterLanding = () => import('@/components/footer/FooterLanding.vue');
const NotFoundView = () => import('@/components/NotFound.vue');
import HeaderView from '@/components/header/Scene.vue';
import SearchView from '@/components/searchResult/Scene.vue';

const relogin = () => import('@/components/auth/relogin/index.vue');

const VacanciesView = () => import('@/routes_new/inner/vacancies/index.vue');
const VacancyArchive = () => import('@/routes_new/inner/vacancies/components/Archive.vue');
const VacancyVoicebotView = () => import('@/components/vacancy/voicebot/Scene.vue');

const ResponsesView = () => import('@/components/responses/Scene.vue');
const Responses = () => import('@/routes_new/inner/responses/Responses.vue');
const ResponseView = () => import('@/components/response/Scene.vue');
const ResponseResumeScene = () => import('@/components/response/resume/Scene.vue');
const ResponseVideointerviewScene = () => import('@/components/response/videointerview/Scene.vue');
const ResponseVoicebotScene = () => import('@/components/response/voicebot/Scene.vue');

const InvitesView = () => import('@/components/invites/Scene.vue');
const InvitesCreationView = () => import('@/components/invites/creation/scene/index.vue');

const CallsView = () => import('@/components/calls/Scene.vue');

// Settings
const VcvSettings = () => import('@/routes_new/inner/settings/VcvSettings');
const VcvSettingsCompany = () => import('@/routes_new/inner/settings/company/VcvSettingsCompany.vue');
const SettingsManagersView = () => import('@/routes_new/inner/settings/managers/Scene.vue');
const SettingsSecurityPasswords = () => import('@/routes_new/inner/settings/security/SettingsSecurityPasswords');
const SettingsDocuments = () => import('@/routes_new/inner/settings/documents/SettingsDocuments');
const VcvSettingsIntegrations = () => import('@/routes_new/inner/settings/integrations/VcvSettingsIntegrations');
const VcvSettingsChatbot = () => import('@/routes_new/inner/settings/chatbot/VcvSettingsChatbot');
const SettingsStatuses = () => import('@/routes_new/inner/settings/statuses/Scene.vue');
const SettingsEmail = () => import('@/routes_new/inner/settings/email/Scene.vue');
const SettingsRates = () => import('@/routes_new/inner/settings/rates/Scene.vue');
const SettingsSmtp = () => import('@/routes_new/inner/settings/smtp/index.vue');
const SettingsLog = () => import('@/routes_new/inner/settings/log/index.vue');

const express_invite = () => import('@/routes_new/express_invite/index.vue');

const HelpView = () => import('@/components/help/Scene.vue');

const AdminHeaderView = () => import('@/components/admin/header/Scene.vue');

const BatChampionshipBusinessUploadPlanScene = () =>
  import('@/process/bat-championship/components/BusinessPlanUpload/Scene.vue');

const Agreement = () => import('@/components/docs/Agreement.vue');
const Confidential = () => import('@/components/docs/Confidential.vue');

const AnalyticsScene = () => import('@/components/analytics/AnalyticsScene.vue');

const VcvBilling = () => import('@/routes_new/inner/billing/VcvBilling.vue');
const VcvBillingTariffs = () => import('@/routes_new/inner/billing/VcvBillingTariffs.vue');

const vacancy = () => import('@/routes_new/inner/vacancy/index.vue');
import vacancy_routes from '@/routes_new/inner/vacancy/routes.js';

const RatesInformer = () => import('@/routes_new/inner/settings/rates/RatesInformer.vue');

const profile = () => import('@/routes_new/inner/profile/index.vue');
import profile_routes from '@/routes_new/inner/profile/routes.js';
const online_interview = () => import('@/routes_new/inner/onlineinterview/index.vue');
const view_record = () => import('@/routes_new/inner/onlineinterview/view_record/index.vue');
const online = () => import('@/routes_new/inner/onlineinterview/online/index.vue');

const private_response = () => import('@/routes_new/inner/response/index.vue');

const admin = () => import('@/routes_new/inner/admin/index.vue');
import admin_routes from '@/routes_new/inner/admin/routes.js';

// import old_layout from '@/layout/old_layout.vue';
import VcvLayout from '@/layout/VcvLayout.vue';

import processInner from '@/process/routesInner.js';

const routes = [
  {
    path: '',
    component: VcvLayout,
    children: [
      {
        path: 'logout',
        beforeEnter: Security.logout,
        name: 'logout',
        meta: {
          title: 'pageTitles.routes.logout'
        }
      },
      {
        path: 'relogin',
        component: relogin,
        props: true,
        name: 'relogin',
        meta: {
          title: 'pageTitles.routes.login',
          customInputFields: true
        }
      },
      {
        path: 'search',
        components: {
          default: SearchView,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        props: {
          header: {
            displayNavigation: true
          }
        },
        name: 'search',
        meta: {
          title: 'pageTitles.routes.search'
        }
      },
      {
        path: 'vacancies/archive',
        components: {
          default: VacancyArchive,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        name: 'vacancies-archive',
        meta: {
          title: 'pageTitles.routes.vacancies.archive'
        }
      },
      {
        path: 'vacancies',
        components: {
          default: VacanciesView,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        name: 'vacancies',
        meta: {
          title: 'pageTitles.routes.vacancies.root'
        }
      },
      {
        path: 'vacancies/:id',
        name: 'vacancy-edit',
        components: {
          default: vacancy,
          header: HeaderView
        },
        props: {
          header: {
            displayNavigation: true
          }
        },
        meta: {
          title: 'pageTitles.routes.vacancies.edit'
        },
        children: vacancy_routes
      },
      {
        path: '/express-invites-popup',
        components: {
          default: express_invite
        },
        name: 'express-invites',
        meta: {
          title: 'pageTitles.routes.expressInvites'
        }
      },
      {
        path: 'responses',
        components: {
          default: ResponsesView,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        name: 'responses',
        meta: {
          title: 'pageTitles.routes.responses.root'
        }
      },
      {
        path: 'responses_new',
        components: {
          default: Responses,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        name: 'responses_new',
        meta: { title: 'pageTitles.routes.responses.root' }
      },
      {
        path: 'response/:id',
        name: 'response_new',
        props: {
          default: route => ({
            responseId: route.params.id,
            paid_to: route.query.paid_to || 'true'
          }),
          header: {
            displayNavigation: true
          }
        },
        components: {
          default: private_response,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        meta: {
          title: 'pageTitles.routes.responses.response'
        }
      },
      {
        path: 'responses/:id',
        components: {
          default: ResponseView,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        name: 'response',
        props: {
          default: route => ({
            responseId: route.params.id,
            paid_to: route.query.paid_to || 'true'
          }),
          header: {
            displayNavigation: true
          }
        },
        meta: {
          title: 'pageTitles.routes.responses.response'
        },
        children: [
          {
            path: 'resume',
            component: ResponseResumeScene,
            name: 'response-resume',
            meta: {
              title: 'pageTitles.routes.responses.resume'
            }
          },

          {
            path: 'videointerview',
            component: ResponseVideointerviewScene,
            name: 'response-videointerview',
            meta: {
              title: 'pageTitles.routes.responses.videoInterview'
            }
          },

          {
            path: 'voicebot',
            component: ResponseVoicebotScene,
            name: 'response-voicebot',
            meta: {
              title: 'pageTitles.routes.responses.voiceBot'
            }
          }
        ]
      },
      {
        path: 'online-interview',
        components: {
          default: online_interview,
          header: HeaderView
        },
        name: 'online-interview',
        meta: {
          title: 'pageTitles.routes.online-interview.root',
          headerOptions: {
            fixed: false
          }
        }
      },
      {
        path: 'online-interview/:token',
        components: {
          default: view_record,
          header: HeaderView
        },
        name: 'online-interview-inner',
        props: {
          default: route => ({ token: route.params.token })
        },
        meta: {
          title: 'pageTitles.routes.online-interview.root',
          headerOptions: {
            fixed: false
          }
        }
      },
      {
        path: 'online/:token',
        components: {
          default: online,
          header: HeaderView
        },
        props: {
          default: route => ({ token: route.params.token })
        },
        name: 'online-inner',
        meta: {
          title: 'pageTitles.routes.online-interview.root',
          online_interview: true
        }
      },
      {
        path: 'invitations',
        components: {
          default: InvitesView,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        name: 'invites',
        meta: {
          title: 'pageTitles.routes.invitations.root'
        }
      },
      {
        path: 'help',
        name: 'help',
        meta: {
          title: 'pageTitles.routes.help'
        },
        props: {
          header: {
            displayNavigation: true
          }
        },
        components: {
          default: HelpView,
          rates_informer: RatesInformer,
          header: HeaderView
        }
      },
      {
        path: 'invitations/new',
        components: {
          default: InvitesCreationView,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        name: 'invites-creation',
        meta: {
          title: 'pageTitles.routes.invitations.new'
        }
      },
      {
        path: 'calls',
        components: {
          default: CallsView,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        meta: {
          title: 'pageTitles.routes.calls'
        }
      },
      {
        path: 'profile',
        components: {
          default: profile,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        meta: {
          title: 'pageTitles.routes.profile.root'
        },
        children: profile_routes
      },
      {
        path: 'billing',
        components: {
          default: VcvBilling,
          header: HeaderView
        },
        meta: {
          title: 'billing.billing',
          disableMinWidth: true
        },
        children: [
          {
            path: 'tariffs',
            component: VcvBillingTariffs,
            name: 'billing-tariffs',
            meta: {
              title: 'billing.billing',
              disableMinWidth: true
            }
          }
        ]
      },
      {
        path: 'settings',
        components: {
          default: VcvSettings,
          // rates_informer: RatesInformer,
          header: HeaderView
        },
        props: {
          header: {
            displayNavigation: true
          }
        },
        meta: {
          title: 'pageTitles.routes.settings.root',
          disableMinWidth: true
        },
        children: [
          {
            path: '',
            redirect: () => ({
              name: 'settings-company'
            }),
            component: VacancyVoicebotView,
            name: 'settings',
            meta: {
              title: 'pageTitles.routes.settings.root',
              disableMinWidth: true
            }
          },
          {
            path: 'company',
            component: VcvSettingsCompany,
            name: 'settings-company',
            meta: {
              title: 'pageTitles.routes.settings.company',
              disableMinWidth: true
            }
          },
          {
            path: 'security',
            component: SettingsSecurityPasswords,
            name: 'settings-security',
            meta: {
              title: 'settings.security.title',
              disableMinWidth: true
            }
          },
          {
            path: 'documents',
            component: SettingsDocuments,
            name: 'settings-documents',
            meta: {
              title: 'billing.company-documents',
              disableMinWidth: true
            }
          },
          {
            path: 'integrations',
            component: VcvSettingsIntegrations,
            name: 'settings-integrations',
            meta: {
              title: 'settings.integrations.title',
              disableMinWidth: true
            }
          },
          {
            path: 'managers',
            component: SettingsManagersView,
            name: 'settings-managers',
            meta: {
              title: 'pageTitles.routes.settings.managers',
              disableMinWidth: true
            }
          },
          {
            path: 'chatbot',
            component: VcvSettingsChatbot,
            name: 'settings-chatbot',
            meta: {
              title: 'chatbot.chatbot',
              disableMinWidth: true
            }
          },
          {
            path: 'statuses',
            component: SettingsStatuses,
            name: 'settings-statuses',
            meta: {
              title: 'pageTitles.routes.settings.statuses',
              disableMinWidth: true
            }
          },
          {
            path: 'email',
            component: SettingsEmail,
            name: 'settings-email',
            meta: {
              title: 'pageTitles.routes.settings.email',
              disableMinWidth: true
            }
          },
          {
            path: 'smtp',
            component: SettingsSmtp,
            name: 'settings-smtp',
            meta: {
              title: 'settings.smtp.title',
              disableMinWidth: true
            }
          },
          {
            path: 'log',
            component: SettingsLog,
            name: 'settings-log',
            meta: {
              title: 'common.navigation.log',
              disableMinWidth: true
            }
          },
          {
            path: 'rates',
            component: SettingsRates,
            name: 'settings-rates',
            meta: {
              title: 'pageTitles.routes.settings.rates',
              disableMinWidth: true
            }
          }
        ]
      },
      {
        path: 'admin',
        components: {
          default: admin,
          header: AdminHeaderView
        },
        name: 'admin',
        redirect: { name: 'admin-companies-list' },
        meta: {
          title: 'Admin',
          is_admin: true
        },
        children: admin_routes
      },
      {
        path: 'bat/competition/:token',
        components: {
          default: BatChampionshipBusinessUploadPlanScene,
          footer: FooterLanding
        },
        name: 'bat-competition',
        props: {
          default: route => ({ token: route.params.token })
        },
        meta: {
          title: 'Battle of minds business plan upload'
        }
      },
      {
        path: ':lang/agreement',
        components: {
          default: Agreement,
          footer: FooterLanding
        },
        name: 'agreement',
        props: {
          default: route => ({ lang: route.params.lang })
        },
        meta: {
          title: 'Пользовательское соглашение',
          disableMinWidth: true
        }
      },
      {
        path: 'confidential',
        components: {
          default: Confidential,
          footer: FooterLanding
        },
        name: 'сonfidential',
        meta: {
          title: 'Политика конфиденциальности',
          disableMinWidth: true
        }
      },
      {
        path: 'analytics',
        name: 'analytics',
        components: {
          default: AnalyticsScene,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        meta: {
          title: 'pageTitles.routes.analytics'
        }
      },
      // this route should be the last in the route file
      {
        path: '*',
        // this is necessary to show profile on a header panel
        // beforeEnter: Security.requireAuth,
        components: {
          default: NotFoundView,
          rates_informer: RatesInformer,
          header: HeaderView
        },
        name: 'notFound',
        meta: {
          title: 'pageTitles.routes.notFound'
        }
      }
    ]
  }
].concat(processInner);

export default routes;
